/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { ServerEventInterfaces, ServerEvents } from 'shared';

export enum AppStandaloneEvents {
  SeeInvitations = '_SeeNotifications',
  TextToastr = '_TextToastr',
}

export { ServerEvents as AppServerEvents };

export type AppEvents = AppStandaloneEvents | ServerEvents;

export interface AppEventMapping extends ServerEventInterfaces {
  [AppStandaloneEvents.SeeInvitations]: { count: number };
  [AppStandaloneEvents.TextToastr]: {
    primaryText: string | React.ReactNode;
    secondaryText?: string | React.ReactNode;
  };
}
